<a
  class="product no-decoration"
  (mouseover)="isHovered = true"
  (mouseleave)="isHovered = false"
  [routerLink]="['/products', product.idProduct]"
>
  <!-- Header -->
  <div class="product__header">
    <div class="product__header__no__heading" *ngIf="product.type === 'Capacitaciones'">
      <img src="assets/icons/no-image.svg" alt="logo proquifa" width="28" height="28">
    </div>
    <div class="product__header__section__brand" *ngIf="product.type !== 'Capacitaciones'">
      <div class="cat__cas">
        <span *ngIf="product.cas"> CAS <strong>{{ product.cas }}</strong></span>
        <span *ngIf="product.catalog">CAT <strong>{{ product.catalog }}</strong></span>
      </div>
      <img
        *ngIf="brandImgPath"
        [src]="brandImgPath"
        alt="product brand"
        class="brand-img"
        width="40"
        height="40"
      />
    </div>
  </div>

  <!-- Img -->
  <div class="product__img">
    <img [src]="presentationImgPath" alt="image product" />

    <button
      *ngIf="enablePreviewViewButton && isHovered"
      class="hover-button"
      (click)="openPreviewViewModal($event)"
    >
      <ng-icon name="heroEye" size="24"/>
      <span>Vista Previa</span>
    </button>
  </div>

  <!-- Details -->
  <div class="product__details">
    <div class="product__details__controlled__label text-orange-700" *ngIf="product.controlled">
      <ng-icon class="icon" size="16" name="heroLockClosed"></ng-icon>
      <span class="text-x-small text-600">Controlado</span>
    </div>

    <div class="product__details__heading">
      <p class="product__details__type" *ngIf="!product.controlled">
        {{ product.type }}
      </p>

      <span class="media-type" *ngIf="product.mediaOutlet">
        {{ product.mediaOutlet }}
      </span>

      <span class="media-type" *ngIf="product.publicationFormat">
        {{ product.publicationFormat }}
      </span>
    </div>

    <p class="text-body text-gray-green-900 product-description">
      {{ product.description }}
    </p>

    <p
      class="text-small-regular text-neutral-500 training-product-description"
      *ngIf="product.trainingProductDescription"
    >
      {{ product.trainingProductDescription }}
    </p>

    <span
      class="text-small-regular text-neutral-500 product-author"
      *ngIf="product.author"
    >
      por {{ product.author }}
    </span>

    <!-- Price -->
    <div class="product__details__shopping" *ngIf="isLogged && product.typeKey !== 'training'">
      <div class="product__details__shopping__price">
        <p class="text-small text-gray-green-500 line-through">
          {{ product.offert.unitPriceWeb| usdCurrency }}
        </p>
        <p class="text-regular-title text-primary-500">
          {{ product.offert.unitPrice | usdCurrency }}
        </p>
      </div>
      <atm-shopping-button [product]="product" />
    </div>

    <div class="product__details__shopping__message" *ngIf="product.typeKey === 'training'">
      <span>Comunícate con Asesor Comercial para cotizar.</span>
    </div>

    <div class="product__details__shopping__price__blurred"  *ngIf="isLogged === false">
      <p class="blurred-text no-select">{{ 1234 | usdCurrency }}</p>
      <span class="login-text text-x-small text-primary-500" (click)="openLoginModal($event)" >
        Inicia sesión para ver precios
      </span>
    </div>

    <!-- Delivery Details -->
    <div class="product__details__delivery">
      <div class="text-x-small instant" *ngIf="hasExistingStock">
        <ng-icon class="icon" size="12" strokeWidth="2" name="heroCheckCircle"></ng-icon>
        <span>Entrega inmediata </span>
      </div>
      <p
        class="text-x-small text-blue-900"
        *ngIf="isProductEligible(product)"
      >
        Envío en <strong class="text-600">{{ product.offert.deliveryTimeDays }} Días</strong>
      </p>
      <p class="text-x-small text-blue-900" *ngIf="product.isbn">
        ISBN <strong class="text-600">{{ product.isbn }}</strong>
      </p>
    </div>

  </div>
</a>

<atm-closable-modal
  [isOpen]="isModalOpen"
  (modalClosedEmitter)="closePreviewModal()"
  *ngIf="enablePreviewViewButton"
>
  <org-product-details-card [product]="product" [showSeeAllDetails]="true"/>
</atm-closable-modal>
